import { useMediaQuery } from "react-responsive"
import { isDesktopMediaQuery } from "../constants/constants"
import Skeleton from "react-loading-skeleton";

const CampaignDetailSkeleton: React.FC = () => {
    const isDesktop = useMediaQuery(isDesktopMediaQuery);
    return (
        <div className="card card-style">
            <Skeleton className="card card-style mx-3 my-3 rounded-4" style={{ height: isDesktop ? '280px' : '180px', width: isDesktop ? '95%' : '91%' }} />
            <div className="content mt-n2">
                <div className="d-flex justify-content-between align-items-center">
                    <Skeleton height={35} className="rounded-4" width={60} />
                    <div className="d-flex justify-content-end align-items-center">
                        {
                            Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} height={35} className="rounded-4 ms-1" width={37} />)
                        }
                    </div>
                </div>
                <Skeleton height={20} className="rounded-4 mt-2" />
                <div className="d-flex flex-wrap mt-2">
                    {
                        Array.from({ length: 3 }).map((_, index) => {
                            return (
                                <Skeleton width={100} height={25} key={index} className="chip mb-0 mt-2 me-2 ps-2 pe-2 bg-gray-light" />
                            );
                        })
                    }
                </div>
                <div className="card shadow-none border-gray-300 mt-4" style={{ borderRadius: '1rem' }}>
                    <div className="card-body p-2">
                        <Skeleton height={25} style={{ width: '225px' }} />
                        <ul className="list-group list-group-flush">
                            {
                                Array.from({ length: 4 }).map((_, i) => {
                                    return (
                                        <li key={i} className="list-group-item px-0 d-flex justify-content-between">
                                            <span className="w-50">
                                                <Skeleton height={20} className="w-75" />
                                            </span>
                                            <span className="right text-end w-50">
                                                <Skeleton className="w-75" height={20} />
                                            </span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
                <Skeleton height={35} className="btn btn-full btn-sm rounded-sm" />
                <div className="mt-4">
                    <Skeleton height={25} width={275} />
                    <Skeleton height={20} className="w-100" />
                    <Skeleton height={20} className="w-100" />
                    <Skeleton height={20} className="w-100" />
                    <Skeleton height={20} className="w-100" />
                </div>
            </div>
        </div>
    )
}

export default CampaignDetailSkeleton